import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { FormCard } from "@/components/ui/form-card";
import { useTranslation } from "react-i18next";
import { CompanyGroupFormFields } from "./_components/create-form-fields";

export function CreateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:CreateCompanyGroup");
  const pageSubtitle = t("common:CompleteRequiredInformationDescription");
  const cardTitle = t("common:Details");

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <FormCard title={cardTitle} titleHidden>
        <CompanyGroupFormFields />
      </FormCard>
    </CenteredLayout>
  );
}
